export enum ListSortOptions {
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc',
  PRICE_ASC = 'price_asc',
  PRICE_DESC = 'price_desc',
}

export const ListSortOptionsLabels = {
  [ListSortOptions.NAME_ASC]: 'Name (A to Z)',
  [ListSortOptions.NAME_DESC]: 'Name (Z to A)',
  [ListSortOptions.PRICE_ASC]: 'Price (Low to High)',
  [ListSortOptions.PRICE_DESC]: 'Price (High to Low)',
}
